module.exports = __webpack_public_path__ + "img/gb.2aa3582f.svg";